import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            hasSreqPermission: 'sreq/hasPermission',
        }),
    },
};
